module.exports = __webpack_public_path__ + "media/images/wine-icon-68bb2c91a5fc4726581fb556d1043727.svg";